<template>
  <div>
    <v-card class="pa-5">
      <v-card-text>
        <v-card-title>
          <h4>{{$t('reports.incidentsInspector')}}</h4>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="filterData()" v-on="on" v-bind="attrs" depressed class="float-right mr-2" color="primary">
                <v-icon small>fas fa-search</v-icon>
              </v-btn>
            </template>
            <span>{{$t('general.search')}}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="resetFilter" v-on="on" v-bind="attrs" depressed class="float-right mr-2" color="primary">
                <v-icon small>fa-solid fa-eraser</v-icon>
              </v-btn>
            </template>
            <span>{{$t('general.resetFilter')}}</span>
          </v-tooltip>
          <v-btn v-if="report3.length > 0" @click="download" :loading="loadingButton" color="primary">
            {{$t('reports.downloadReport')}}
            <v-icon small class="ml-2">fas fa-cloud-download-alt</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form v-model="valid" lazy-validation ref="form">
            <v-row dense>
              <v-col cols="4">
                <v-text-field
                  v-model="filter.checkList"
                  :rules="rules.textNoSpecialChars"
                  class="ml-2"
                  outlined
                  dense
                  label="CheckList"
                />
              </v-col>
              <v-col cols="4">
                <v-autocomplete
                clearable
                outlined
                dense
                :items="sites"
                item-text="name"
                item-value="id"
                v-model="filter.site"
                :label="$t('general.yard')"
                class="ml-2"/>
              </v-col>
              <v-col cols="4">
                <v-autocomplete
                  clearable
                  outlined
                  dense
                  :items="users"
                  :item-text="getInspector" 
                  item-value="id"
                  v-model="filter.inpector"
                  multiple
                  label="Inspector"
                  class="ml-2">
                  <template v-slot:selection="data">
                    <v-chip small color="primary">
                      {{ data.item.name }} {{ data.item.last_name }}
                    </v-chip>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col v-if="filter.dateRange" cols="4">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filter.date_start"
                      :label="$t('general.startDate')"
                      outlined
                      dense
                      prepend-icon="event"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    no-title
                    color="primary"
                    v-model="filter.date_start"
                    @input="handleDateStartSelection"
                    :allowed-dates="allowedStartDates"
                    :day-style="getDayStyle"
                  />
                </v-menu>
              </v-col>
              <v-col v-if="filter.dateRange" cols="4">
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filter.date_end"
                      :label="$t('general.endDate')"
                      outlined
                      dense
                      prepend-icon="event"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    no-title
                    color="primary"
                    v-model="filter.date_end"
                    @input="menu2 = false"
                    :allowed-dates="allowedEndDates"
                    :day-style="getDayStyle"
                  />
                </v-menu>
              </v-col>
              <v-col cols="4">
                <v-checkbox v-model="filter.dateRange" :label="$t('general.dateRange')" hide-details class="mt-0" color="primary"/>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-overlay absolute opacity="0" :value="loadingTable"/>
        <v-data-table
          :loading="loadingTable"
          :loading-text="$t('general.loading')"
          :headers="headers"
          :items="report3"
          :single-expand="false"
          :server-items-length="optionsDataTable.totalItems"
          :options.sync="optionsDataTable"
          :footer-props="{ 'items-per-page-options': [50, 70, 100] }"
          @update:page="get"
          @update:items-per-page="get"
          @update:sort-by="get"
          @update:sort-desc="get"
          item-key="id"
        >
          <template v-slot:item.inspection:consecutive_number="{ item }">
          {{ item.section.inspection ? item.section.inspection.consecutive_number : 'N/A' }}
          </template>
          <template v-slot:item.inspection:name="{ item }">
          {{ item.section.inspection ? item.section.inspection.name : 'N/A' }}
          </template>
          <template v-slot:item.inspection:created_at="{ item }">
          {{ item.section.inspection ? item.section.inspection.created_at : 'N/A' }}
          </template>
          <template v-slot:item.site:name="{ item }">
          {{ item.section.inspection.site ? item.section.inspection.site.name : 'N/A' }}
          </template>
          <template v-slot:item.user:name="{ item }">
          {{ item.section.inspection.user ? (item.section.inspection.user.name + ' ' + item.section.inspection.user.last_name) : 'N/A' }}
          </template>
          <template v-slot:item.operator:name="{ item }">
            {{ item.section.inspection ? (item.section.inspection.current_operator || ((item.section.inspection.operator && item.section.inspection.operator.length > 0) ? item.section.inspection.operator[0].name : 'N/A')) : 'N/A' }}
          </template>
          <template v-slot:item.section:name="{ item }">
          {{ item.section ? item.section.name : 'N/A' }}
          </template>
          <template v-slot:item.damage_level="{ item }">
          {{ translateDamageLevel(item.damage_level) }}
          </template>
          <template v-slot:item.plate_number="{ item }">
            {{ item.section.unit && item.section.unit.plates && item.section.unit.plates.length > 0 ? item.section.unit.plates[0].plate_number : 'N/A' }}
          </template>
          <template v-slot:item.unitNumber="{ item }">
          {{ item.section.unit ? item.section.unit.unit_number : 'N/A' }}
          </template>
          <template v-slot:item.unit_types:name="{ item }">
          {{ item.section.unit_types ? item.section.unit_types[0].alias : 'N/A' }}
          </template>
          <template v-slot:item.property="{ item }">
          <span>
            {{ item.section.inspection.truck ? translateProperty(item.section.inspection.truck.owner) : 'N/A' }}
          </span>
          </template>
          <template v-slot:item.owne="{ item }">
          {{ item.section.inspection.truck ? item.section.inspection.truck.owner_name : 'N/A' }}
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>
  
<script>
  export default {
    data () {
      return {
        filterModal: false,
        valid: true,
        loadingTable: false,
        loadingButton: false,
        showFilterMessage: true,
        firstLoad: true,
        menu: false,
        menu2: false,
        link: '',
        options: {
          itemsPerPage: 15,
          page: 1,
          total: 0
        },
        optionsDataTable: {
          itemsPerPage: 15,
          page: 1,
          total: 0
        },
        filter: {
          site_id: null,
          inpector_id: null,
          find: '',
          dateRange: true,
          date_start: this.returnStartDate(),
          date_end: this.returnEndDate()
        },
        report3: [],
        sites: [],
        users: []
      }
    },
    watch: {
      sites (val) {
        if (val.length > 0) this.options.itemsPerPage = 10
      },
      'filter.dateRange' (val) {
        if (!val) {
          this.filter.date_start = null
          this.filter.date_end = null
        } else {
          this.filter.date_start = this.returnStartDate()
          this.filter.date_end = this.returnEndDate()
        }
      }
    },
    computed: {
      headers() {
        return [
          {
            text: this.$t('general.noInspection'),
            align: 'center',
            value: 'inspection:consecutive_number'
          },
          {
            text: 'CheckList',
            align: 'center',
            value: 'inspection:name'
          },
          {
          text: this.$t('general.date'),
          align: 'center',
          value: 'inspection:created_at'
          },
          {
            text: this.$t('general.yard'),
            align: 'center',
            value: 'site:name'
          },
          {
            text: 'Inspector',
            align: 'center',
            value: 'user:name'
          },
          {
            text: this.$t('general.operat'),
            align: 'center',
            value: 'operator:name'
          },
          {
            text: this.$t('general.section'),
            align: 'center',
            value: 'section:name',
            sortable: false
          },
          {
            text: this.$t('monitoring.question'),
            align: 'center',
            value: 'name'
          },
          {
            text: this.$t('monitoring.levelDamage'),
            align: 'center',
            value: 'damage_level'
          },
          {
            text: this.$t('general.damageNotes'),
            align: 'center',
            value: 'issues_notes'
          },
          {
            text: this.$t('general.comments'),
            align: 'center',
            value: 'comment'
          },
          {
            text: this.$t('general.plate'),
            align: 'center',
            value: 'plate_number',
            sortable: false
          },
          {
            text: this.$t('general.noEco'),
            align: 'center',
            value: 'unitNumber',
            sortable: false
          },
          {
            text: this.$t('general.unitType'),
            align: 'center',
            value: 'unit_types:name'
          },
          {
            text: this.$t('general.property'),
            align: 'center',
            value: 'property',
            sortable: false
          },
          {
            text: this.$t('general.owne'),
            align: 'center',
            value: 'owne',
            sortable: false
          }
        ]
      },
      rules () {
        return this.$validationRules()
      }
    },
    created () {
      this.$store.dispatch('sites/get', { event: { context: this, item: { perPage: -1, page: 1 } } })
      this.$store.dispatch('users/getInspect', { event: { context: this, item: { perPage: -1, page: 1 } } })
      this.$store.dispatch('unitTypes/getAll', { event: { context: this } })
      this.get()
    },
    methods:{
      returnStartDate() {
        const now = new Date()
        return new Date(now.getFullYear(), now.getMonth(), 1).toISOString().substr(0, 10)
      },
      returnEndDate() {
        const now = new Date()
        return new Date(now.getFullYear(), now.getMonth() + 1, 0).toISOString().substr(0, 10)
      },
      resetFilter() {
        this.filter = {
          site_id: null,
          inpector_id: null,
          find: '',
          dateRange: true,
          date_start: this.returnStartDate(),
          date_end: this.returnEndDate()
        }

        if(this.optionsDataTable.page === 1) return this.get()

        this.optionsDataTable.page = 1
      },
      filterData(){
        if(!this.$refs.form.validate()) return this.showNotification(this.$t('general.errorFilterMessage'), 'warn', -1)

        if(this.optionsDataTable.page === 1) return this.get()

        this.optionsDataTable.page = 1
      },
      getInspector(user) {
        return `${user.name} ${user.last_name}`;
      },
      viewItem (id) {
        this.$router.push('/inspectionUnitTypes/view/' + id)
      },
      download () {
        if(!this.$refs.form.validate()) return this.showNotification(this.$t('general.errorFilterMessage'), 'warn', -1)

        this.loadingButton = true
      
        this.$store.dispatch('reports/getIncidentsInspectorDoc', {
          event: {
            context: this,
            params: {
              ord: this.optionsDataTable.sortDesc && this.optionsDataTable.sortDesc[0] ? 'ASC' : 'DESC',
              perPage: this.optionsDataTable.itemsPerPage,
              page: this.optionsDataTable.page,
              type: 'download',
              date_start: this.filter.date_start === null ? undefined : this.filter.date_start,
              date_end: this.filter.date_end === null ? undefined : this.filter.date_end,
              site_id: this.filter.site,
              inpector_id: this.filter.inpector,
              find: this.filter.checkList,
              sortKey: this.optionsDataTable.sortBy.length > 0 ? this.optionsDataTable.sortBy[0] : 'id'
            }
          }
        })
      },
      get () {
        this.loadingTable = true
        
        this.$store.dispatch('reports/getIncidentsInspector', {
          event: {
            context: this,
            params: {
              date_start: this.filter.date_start === null ? undefined : this.filter.date_start,
              date_end: this.filter.date_end === null ? undefined : this.filter.date_end,
              inpector_id: this.filter.inpector,
              site_id: this.filter.site,
              perPage: this.optionsDataTable.itemsPerPage,
              page: this.optionsDataTable.page,
              find: this.filter.checkList,
              type: 'json',
              sortKey: (this.optionsDataTable.sortBy && this.optionsDataTable.sortBy.length > 0) ? this.optionsDataTable.sortBy[0] : 'id',
              ord: this.optionsDataTable.sortDesc && this.optionsDataTable.sortDesc[0] ? 'ASC' : 'DESC'
          }
          }
        })
      },
      translateDamageLevel(value) {
        const damageLevelMap = {
          'SOFT': this.$t('inspections.slight'),
          'MODERATE': this.$t('inspections.moderate'),
          'HARD': this.$t('inspections.high'),
          'NONE': this.$t('inspections.none')
        };
        return damageLevelMap[value] || 'N/A';
      },
      translateProperty(value) {
        const propertyMap = {
          'OWN': this.$t('units.OWN'),
          'EXTERNAL': this.$t('units.EXTERNAL')
        }

        return propertyMap[value] || 'N/A';
      },
      handleDateStartSelection(date) {
        this.filter.date_start = date;
        this.updateDateEnd();
        this.menu = false;
      },
      allowedStartDates() {
        return true;
      },
      allowedEndDates(date) {
        if (!this.filter.date_start) return true;

        const startDate = new Date(this.filter.date_start);
        const endDateLimit = new Date(startDate);
        endDateLimit.setDate(startDate.getDate() + 29);

        return new Date(date) >= startDate && new Date(date) <= endDateLimit;
      },
      updateDateEnd() {
        if (this.filter.date_start) {
          const startDate = new Date(this.filter.date_start);
          const endDateLimit = new Date(startDate);
          endDateLimit.setDate(startDate.getDate() + 29);

          this.filter.date_end = endDateLimit.toISOString().substr(0, 10);
        }
      },
      getDayStyle(date) {
        if ((this.filter.date_start && this.allowedEndDates(date)) || (!this.filter.date_start && this.allowedStartDates(date))) {
          return null;
        }
        return { backgroundColor: 'rgba(0, 0, 0, 0.1)', color: 'gray' };
      }
    }
  }
</script>